import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { VODCSSModules } from 'shared/utils/wix-connect';

import withTooltip, { adaptShowStatePropsToClassName } from 'shared/components/with-tooltip/with-tooltip';

import styles from './button.styl';


@VODCSSModules(styles)
export class GenericButton extends React.Component {

  static propTypes = {
    label: React.PropTypes.any,
    children: React.PropTypes.any,
    roundedRect: React.PropTypes.bool,
    renderAsLink: React.PropTypes.bool,
    onClick: React.PropTypes.func,
    getRef: React.PropTypes.func,
  };

  static defaultProps = {
    roundedRect: false,
    renderAsLink: false,
    onClick: _.noop,
    getRef: _.noop,
  };

  @autobind
  handleLinkClick(event) {
    event.preventDefault();
    this.props.onClick(event);
  }

  render() {
    const { label, children, roundedRect, getRef, renderAsLink } = this.props;

    const styleNames = classnames('button', {
      'rounded-rect': roundedRect,
    });

    const props = _({})
      .assign(this.props)
      .assign({
        children: label || children,
        styleName: styleNames,
        ref: getRef,
      })
      .omit('styles', 'label', 'roundedRect', 'renderAsLink', 'getRef', 'intl', 'settings', 'biEvent', 'biError')
      .value();

    if (!renderAsLink) {
      return (
        <button {...props} />
      );
    }

    return (
      <a href=""
         {...props}
         onClick={this.handleLinkClick} />
    );
  }
}


function generateButtonVariant(styleName) {

  @VODCSSModules(styles)
  class ButtonVariant extends React.Component {
    render() {
      const props = _.omit(this.props, 'styles');

      return (
        <GenericButton {...props}
                       styleName={styleName} />
      );
    }
  }

  return ButtonVariant;
}


export const LinkButton = generateButtonVariant('link-button');
export const LinkPremiumButton = generateButtonVariant('link-button link-premium-button');
export const PrimaryButton = generateButtonVariant('primary-button');
export const SecondaryButton = generateButtonVariant('secondary-button');
export const DangerPrimaryButton = generateButtonVariant('danger-primary-button');
export const DangerSecondaryButton = generateButtonVariant('danger-secondary-button');
export const PremiumPrimaryButton = generateButtonVariant('premium-primary-button');
export const PremiumSecondaryButton = generateButtonVariant('premium-secondary-button');
export const TransparentWhiteButton = generateButtonVariant('transparent-white-button');
export const WhiteBlueButton = generateButtonVariant('white-blue-button');

export const TooltipPrimaryButton = withTooltip(adaptShowStatePropsToClassName(PrimaryButton));



// WEBPACK FOOTER //
// ./src/shared/components/button/button.js